<template>
  <div>
      <header class="bar bar-nav">
        <a class="icon icon-left pull-left" @click="tolast"></a>
<!--        <h1 class="title"><span v-if="selected!=='累计'">{{chooseDate}}</span>{{selected}}对账单</h1>-->
        <h1 class="title">{{groupName}}对账单</h1>
      </header>
      <footer class="bar bar-footer-secondary"  style="color: white;height: 3.5rem;margin-bottom: -2rem;" v-if="summary&&statementGuid!=''&&statementGuid!=null">
        <div style="text-align: center;color: red;font-size: .8rem;margin-top: .1rem">请您核对账单</div>
        <div>
          <div @click="submit()" style="width: 45%;float: left;border: 1px;text-align: center;"><span style="color:white;background-color: grey"><a class="button button-round" style="height: 1.5rem;  color: white;background-color: rgb(8, 148, 236);font-size: 18px" > 确认</a></span></div>
          <div style="width: 10%;float: left;border: 1px;text-align: center;margin-top: 10px"> </div>
          <div @click="senEmail()" style="width: 45%;float: left;border: 1px;text-align: center;"> <span style="background-color: #0894ec;" ><a class="button button-round" style="  height: 1.5rem;  color: white;background-color: rgb(8, 148, 236);font-size: 18px">有问题，请联系我</a></span></div>
        </div>

      </footer>


        <div class="content" >
          <div class="content-block-title" style="margin-top:1rem;font-size:.8rem">{{selected}}<span v-if="selected!=='累计'">:</span>{{chooseDate}}</div>
          <div style="margin-top: 1rem;font-size: 14px;background-color: white;height: 70px;margin-left: 10px;margin-right: 10px">
            <div v-if="selected!=='累计'">
              <div class="jine" >
                <div>{{selected}}消费金额</div>
                <div style="margin-top: 10px;color: #0f60c8;">{{summary.consumedMoneySum}}元</div>
              </div>
              <div class="jine" >
                <div>{{selected}}交付金额</div>
                <div style="margin-top: 10px;color: #0f60c8;">{{summary.deliveryMoneySum}}元</div>
              </div>
              <div class="jine">
                <div>账单金额</div>
                <div style="margin-top: 10px;color: #0f60c8;">{{summary.billAmount}}元</div>
              </div>
              <div class="jine">
                <div>{{selected}}未清金额</div>
                <div style="margin-top: 10px;color: #0f60c8;">{{summary.balanceAmount}}元</div>
              </div>
            </div>
            <div v-else>
              <div class="jine" >
                <div>消费总金额</div>
                <div style="margin-top: 10px;color: #0f60c8;">{{summary.consumedMoneySum}}元</div>
              </div>
              <div class="jine" >
                <div>已发货总金额</div>
                <div style="margin-top: 10px;color: #0f60c8;">{{summary.deliveryMoneySum}}元</div>
              </div>
              <div class="jine">
                <div>已开票总金额</div>
                <div style="margin-top: 10px;color: #0f60c8;">{{summary.invoiceMoneySum}}元</div>
              </div>
              <div class="jine">
                <div>回款总金额</div>
                <div style="margin-top: 10px;color: #0f60c8;">{{summary.invoiceReceivedMoneySum}}元</div>
              </div>
            </div>
          </div>
          <div v-if="selected=='累计'">
            <div style=" font-size: 16px;margin-top: 20px;margin-left: 10px" v-if="invoiceList.length>0">
              明细（已开票未回款）
            </div>
            <div v-if="invoiceList.length>0" style="margin-top: .5rem;font-size: 14px;background-color: white;margin-left: 10px;margin-right: 10px">
              <table class="account-item" style="width: 100%;">
                <tbody>
                <tr>
                  <th style="width: 28%">
                    发票编号
                  </th>

                  <th style="width: 33%">
                    金额
                  </th>
                  <th style="width: 33%;padding-right: 5px;">
                    发票开具日期
                  </th>
                </tr>
                <tr v-for="invoice in invoiceList">
                  <td class="idxn">
                   {{invoice.invoiceNo}}
                  </td>
                  <td>
                    {{invoice.invoiceMoney}}元
                  </td>
                  <td class="idxn">
                    {{invoice.invoiceBillingDT}}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="consumeContractList.length>0" style=" font-size: 16px;margin-top: 20px;margin-left: 10px;margin-bottom: 10px">
            消费明细
          </div>
          <div class="list-block" style="margin: 0rem" v-if="selected!=='累计'&& consumeContractList.length>0">
            <contractInfoBox :contractInfo='contractInfo' :type="type" :selected="selected"></contractInfoBox>
            <div class="list-block media-list" style="margin: 0rem" v-for="consumeContract in consumeContractList">
              <div style="margin-left: 10px;margin-right: 10px">
                <ul style="margin-bottom: 10px;font-size: .8rem ">
                  <li class="item-content item-link">
                    <div class="item-inner"  @click="showcontractInfo(consumeContract,'消费明细')">
                      <div>
                        <div class="xfxq-i-1 clearfix">
                          <span class="fl sp1">{{consumeContract.contractName}}</span>
                        </div>
                        <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                          <span class="fl">基因名称：
                            <span v-if="consumeContract.geneNames!==''">{{consumeContract.geneNames}}</span>
                            <span v-else>-</span>
                          </span>
                          <span class="fr money">{{consumeContract.contractMoney}}元</span>
                        </div>
                        <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                          <span class="fl">合同编号：{{consumeContract.contractNo}}</span>
                          <span class="fr" style="margin-left: 20px">{{consumeContract.contractStartDT}}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="list-block media-list" v-if="selected==='累计'" style="margin: 0rem">
            <contractInfoBox :contractInfo='contractInfo' :type="type" :selected="selected"></contractInfoBox>
            <div v-for="showdata1 in timeList1" style="margin-left: 10px;margin-right: 10px">
              <ul  style="margin-bottom: 10px">
                <li>
                  <a  class="item-link item-content">
                    <div class="item-inner" @click="showcontract(showdata1)">
                      <div class="item-title" style="text-align: center">{{showdata1.data}}年</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul v-for="consumeContract in consumeContractList" style="margin-bottom: 10px;font-size: .8rem" v-if="showdata1.isshow && consumeContract.contractStartDT.substring(0, 4) === showdata1.data ">
                <li class="item-content item-link">
                  <div class="item-inner">
                    <div  @click="showcontractInfo(consumeContract, '消费明细')">
                      <div>
                        <div class="xfxq-i-1 clearfix">
                          <span class="fl sp1">{{consumeContract.contractName}}</span>
                        </div>
                        <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                          <span class="fl">基因名称：
                            <span v-if="consumeContract.geneNames!==''">{{consumeContract.geneNames}}</span>
                            <span v-else>-</span>
                          </span>
                          <span class="fr money">{{consumeContract.contractMoney}}元</span>
                        </div>
                        <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                          <span class="fl">合同编号：{{consumeContract.contractNo}}</span>
                          <span class="fr" style="margin-left: 20px">{{consumeContract.contractStartDT}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="deliverContractList.length>0" style=" font-size: 16px;margin-top: 20px;margin-left: 10px;margin-bottom: 10px">
            交付明细
          </div>
          <div class="list-block" style="margin: 0rem" v-if="selected!== '累计' && deliverContractList.length>0">
            <contractInfoBox :contractInfo='contractInfo' :type="type" :selected="selected"></contractInfoBox>
            <div class="list-block media-list" style="margin: 0rem" v-for="deliverContract in deliverContractList">
              <div style="margin-left: 10px;margin-right: 10px">
                <ul style="margin-bottom: 10px;font-size: .8rem ">
                  <li class="item-content item-link">
                    <div class="item-inner"  @click="showcontractInfo(deliverContract, '交付明细')">
                      <div>
                        <div class="xfxq-i-1 clearfix">
                          <span class="fl sp1">{{deliverContract.contractName}}</span>
                        </div>
                        <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                          <span class="fl">基因名称：{{deliverContract.geneNames}}</span>
                          <span class="fr money">{{deliverContract.contractMoney}}元</span>
                        </div>
                        <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                          <span class="fl">合同编号：{{deliverContract.contractNo}}</span>
                          <span class="fr" style="margin-left: 20px">{{deliverContract.deliveryDT}}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="list-block media-list" v-if="selected==='累计'" style="margin: 0rem">
            <contractInfoBox :contractInfo='contractInfo' :type="type" :selected="selected"></contractInfoBox>
            <div v-for="showdata2 in timeList2" style="margin-left: 10px;margin-right: 10px">
              <ul  style="margin-bottom: 10px">
                <li>
                  <a  class="item-link item-content">
                    <div class="item-inner" @click="showcontract(showdata2, '累计')">
                      <div class="item-title" style="text-align: center">{{showdata2.data}}年</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul  v-for="deliverContract in deliverContractList" style="margin-bottom: 10px;font-size: .8rem" v-if="showdata2.isshow && deliverContract.deliveryDT.substring(0, 4) === showdata2.data ">
                <li class="item-content item-link">
                  <div class="item-inner">
                    <div  @click="showcontractInfo(deliverContract, '交付明细')">
                      <div>
                        <div class="xfxq-i-1 clearfix">
                          <span class="fl sp1">{{deliverContract.contractName}}</span>
                        </div>
                        <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                          <span class="fl">基因名称：{{deliverContract.geneNames}}</span>
                          <span class="fr money">{{deliverContract.contractMoney}}元</span>
                        </div>
                        <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                          <span class="fl">合同编号：{{deliverContract.contractNo}}</span>
                          <span class="fr" style="margin-left: 20px">{{deliverContract.deliveryDT}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
    </div>
  </div>
</template>


<script>
  import $ from 'jquery'
  import {mapState, mapMutations} from 'vuex'
  import contractInfoBox from './ContractInfoBox.vue'
  import EMKT from '../../../emkt.js'
  export default {
    mounted () {
      this.fetchData()
    },
    components: {contractInfoBox},
    created () {
      this.fetchData()
    },
    computed: {
      ...mapState([
        'sessionInfo', 'showContractInfoBox'
      ])
    },
    data () {
      return {
        sumdata: {},
        contractInfo: {},
        questionUrl: '/emktResources/resocurces/img/question.png',
        timeList1: [],
        timeList2: [],
        selected: '',
        chooseDate: '',
        billInfo: {},
        summary: {},
        consumeContractList: [],
        deliverContractList: [],
        invoiceList: [],
        type: '',
        statementGuid: ''
      }
    },
    watch: {
      '$route.query.type': function (val) {
        this.selected = this.$route.query.type
      },
      '$route.query.chooseDate': function (val) {
        this.chooseDate = this.$route.query.chooseDate
      },
      '$route.query.groupName': function (val) {
        this.groupName = this.$route.query.groupName
      }
    },
    methods: {
      ...mapMutations(['SETCONTRCTINfFOBOX']),

      fetchData () {
        this.selected = this.$route.query.type
        this.chooseDate = this.$route.query.chooseDate
        this.groupName = this.$route.query.groupName
        this.billInfo = EMKT.getLocalStorage('billInfo')
        if (this.billInfo) {
          console.log('billInfo->', EMKT.getLocalStorage('billInfo'))
          // 账户总览
          this.summary = this.billInfo.summary
          // 流水号
          this.statementGuid = this.billInfo.statementGuid
          // 账户消费明细
          this.consumeContractList = this.billInfo.consumeContractList
          // 账户交付明细
          this.deliverContractList = this.billInfo.deliverContractList
          // 发票明细
          this.invoiceList = this.billInfo.invoiceList
          if (this.selected === '累计') {
            var _this = this
            var list1 = _this.billInfo.consumeContractList
            var list2 = _this.billInfo.deliverContractList
            _this.timeList1 = []
            _this.timeList2 = []
            var newtimeList1 = []
            var newtimeList2 = []
            for (var i in list1) {
              console.log(list1[i].contractStartDT.substring(0, 4))
              if (newtimeList1.indexOf(list1[i].contractStartDT.substring(0, 4)) === -1) {
                newtimeList1.push(list1[i].contractStartDT.substring(0, 4))
                var showdata1 = {}
                showdata1.isshow = false
                showdata1.data = list1[i].contractStartDT.substring(0, 4)
                _this.timeList1.push(showdata1)
              }
            }
            for (var j in list2) {
              console.log(list2[j].deliveryDT.substring(0, 4))
              if (newtimeList2.indexOf(list2[i].deliveryDT.substring(0, 4)) === -1) {
                newtimeList2.push(list2[i].deliveryDT.substring(0, 4))
                var showdata2 = {}
                showdata2.isshow = false
                showdata2.data = list2[i].deliveryDT.substring(0, 4)
                _this.timeList2.push(showdata2)
              }
            }
          }
        }
      },
      tolast () {
        this.$router.push('/user/myAccountChecked')
      },
      showcontractInfo (contract, type) {
        this.contractInfo = contract
        this.type = type
        console.log(this.showContractInfoBox)
        console.log('contract->', this.contractInfo)
        this.SETCONTRCTINfFOBOX(true)
      },
      senEmail () {
        var _this = this
        _this.gcapi('contactUsForBill', _this.statementGuid
        ).then((response) => {
          alert('您的反馈已收到，我们将会尽快联系您，感谢您对吉凯基因的支持。')
        })
      },
      submit () {
        var _this = this
        _this.gcapi('confirmBill', _this.statementGuid
        ).then((response) => {
          if (response.body.code === 0) {
            $.toast('感谢您对吉凯基因的支持!')
          }
        })
      },
      showcontract (showdata) {
        if (showdata.isshow) {
          showdata.isshow = false
        } else {
          showdata.isshow = true
        }
      }
    }
  }
</script>


<style scoped>
  .item-inner {
    padding-bottom: 0rem
  }
  .jine {
    width: 25%;
    float:left;
    text-align: center;
    margin-top: 10px;
  }
  .jine1 {
    width: 25%;
    float:left;
    text-align: center;
    margin-top: 10px;
  }
  tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
  }
  .account-item tr:first-child {
    color: #333333;
    font-size: 14px;
  }
  .account-item tr {
    height: 48px;
    border-bottom: 1px solid #e5e5e5;
    text-align: center;
  }
  .account-item tr th:nth-child(1) {
     width: 23%;
   }
  .account-item tr th {
    text-align: center;
  }
  .account h4 {
    color: #333333;
    font-size: 18px;
    margin-top: 37px;
  }
  .idxn {
    font-size: 12px;
    color: #585858;
  }
  .idxr {
    font-size: 12px;
    color: #e81b05;
    margin-left: 10px;
    cursor: pointer;
    position: relative;
  }
  .idxr span:before {
    content: '';
    width: 18px;
    height: 16px;
    display: inline-block;
    /*background: url(./../img/yichangguanli.png) no-repeat center;*/
  }
  .xfxq-i {
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
    margin-bottom: 10px;
  }
  .item_watch {
    cursor: pointer;
  }
  .xfxq-i-1 .sp1 {
    font-size: 16px;
    color: #333;
    width: 95%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .fl {
    float: left;
  }
  .clearfix:after {
    display: block;
    content: "";
    clear: both;
  }
  .xfxq-i-1 {
    padding: 3px 0;
    color: #666;
  }
  .fl {
     float: left;
   }
  .xfxq-i-1 .money {
    font-weight: 700;
  }
  .fr {
    float: right;
  }
  .continer{

    height:100px;

    width:100px;

    background-color: aqua;

  }
  fade{
    width:100%;
    height:100%;
    background:rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
  }
  /*弹出层*/
  .succ-pop{
    width: 400px;
    height: 300px;
    background: #fff;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -200px;
    margin-top: -150px;
    z-index: 999;
    border-radius: 5px;
  }
  .succ-pop h3.title{
    text-align: center;
    font-size: 22px;
    color: #ce002c;
  }
  .classfy{
    margin-left: 10px;
    margin-top: 1rem;
    font-size: 14px;
    background-color: white;
    height: 30px;
    width:160px;
    border-radius: 5px;
    line-height: 30px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// AccountChecked.vue?72aa1832